<template>
  <div class="container-fluid autenticacao">
    <div class="card autenticacao-card autenticacao-card--denuncia">
      <div class="card-header">
        <div class="card-header-content">
          <div class="card-title-group">
            <div class="card-icon-badge card-icon-badge--danger">
              <i class="pi pi-exclamation-triangle"></i>
            </div>
            <div>
              <h5 class="panel-title">{{ labelPagina }}</h5>
              <p class="panel-subtitle">Realize uma {{ labelPagina }} relacionada à Prestação de Serviços</p>
            </div>
          </div>
        </div>
      </div>
      <div id="topo" class="card-body">
        <form name="form" @submit.prevent="onSubmit">
          <div class="form-title-links">
            <span class="form-title">Preencha as informações abaixo para formalizar a sua solicitação.</span>
          </div>

          <Panel :header="'Tipo ' + labelPagina">
            <div class="row">
              <div class="col-12 col-md-6 mb-2">
                <span class="p-fluid">
                  <Dropdown
                    id="tpDenuncia"
                    v-model="selectedTipoDenuncia"
                    :options="tiposDenuncia"
                    optionLabel="name"
                    :placeholder="'Selecione um Tipo de ' + labelPagina"
                    class="dropdown-modern"
                  />
                </span>
              </div>
            </div>
          </Panel>
          <Panel :header="labelTomador" v-if="selectedTipoDenuncia && selectedTipoDenuncia.key === 'I'">
            <div class="row">
              <div class="col-md-3 mb-2">
                <label for="tpDenunciante">Tipo *:</label>
                <span class="p-fluid">
                  <Dropdown
                    id="tpDenunciante"
                    v-model="selectedTipoDenunciante"
                    :options="tiposPessoa"
                    optionLabel="name"
                    placeholder="Selecione um Tipo de Denunciante"
                    class="dropdown-modern"
                  />
                </span>
              </div>
              <div class="col-md-3 mb-2">
                <label for="cpfCnpjDenunciante"
                  >{{
                    this.selectedTipoDenunciante && this.selectedTipoDenunciante.key == 'J' ? 'CNPJ:' : 'CPF:'
                  }}
                  *:</label
                >
                <span class="p-fluid">
                  <template v-if="selectedTipoDenunciante && selectedTipoDenunciante.key == 'J'">
                    <InputMask
                      v-model="denuncia.cpfCnpjDenunciante"
                      key="J"
                      id="cpfCnpjDenunciante"
                      mask="**.***.***/****-99"
                      placeholder="CNPJ"
                      style="text-transform: uppercase;"
                    />
                  </template>
                  <template v-else>
                    <InputMask
                      v-model="denuncia.cpfCnpjDenunciante"
                      key="F"
                      id="cpfCnpjDenunciante"
                      mask="999.999.999-99"
                      placeholder="CPF"
                    />
                  </template>
                </span>
                <small v-show="validationErrors.cpfCnpjDenunciante" class="p-error"
                  >{{ this.selectedTipoDenunciante && this.selectedTipoDenunciante.key == 'J' ? 'CNPJ' : 'CPF' }}
                  {{ labelTomador }} é Obrigatório.</small
                >
              </div>
              <div class="col-md-6 mb-2">
                <label for="nomeDenunciante">Nome *:</label>
                <span class="p-fluid">
                  <InputText v-model="denuncia.nomeDenunciante" id="nomeDenunciante" maxlength="80" />
                </span>
                <small v-show="validationErrors.nomeDenunciante" class="p-error"
                  >Nome {{ labelTomador }} é Obrigatório.</small
                >
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-2">
                <label>E-mail:</label>
                <span class="p-fluid">
                  <InputText v-model="denuncia.emailDenunciante" type="text" maxlength="100" />
                </span>
              </div>
            </div>
          </Panel>
          <Panel :header="labelPrestador">
            <div class="row">
              <div class="col-md-3 mb-2">
                <label for="tpDenunciado">Tipo de Pessoa *:</label>
                <span class="p-fluid">
                  <Dropdown
                    id="tpDenunciado"
                    v-model="selectedTipoDenunciado"
                    :options="tiposPessoa"
                    optionLabel="name"
                    placeholder="Selecione um Tipo de Denunciado"
                    class="dropdown-modern"
                  />
                </span>
              </div>
              <div class="col-md-3 mb-2">
                <label for="cpfCnpjDenunciado"
                  >{{
                    this.selectedTipoDenunciado && this.selectedTipoDenunciado.key == 'J' ? 'CNPJ:' : 'CPF:'
                  }}
                  *:</label
                >
                <span class="p-fluid">
                  <template>
                    <div class="p-inputgroup">
                      <template v-if="selectedTipoDenunciado && selectedTipoDenunciado.key == 'J'">
                        <InputMask
                          @blur="searchContribuintePorCpfCnpj()"
                          v-model="denuncia.cpfCnpjDenunciado"
                          key="J"
                          id="cpfCnpjDenunciado"
                          mask="**.***.***/****-99"
                          placeholder="CNPJ"
                        />
                      </template>
                      <template v-else>
                        <InputMask
                          @blur="searchContribuintePorCpfCnpj()"
                          v-model="denuncia.cpfCnpjDenunciado"
                          key="F"
                          id="cpfCnpjDenunciado"
                          mask="999.999.999-99"
                          placeholder="CPF"
                        />
                      </template>
                      <Button
                        @click="searchContribuintePorCpfCnpj()"
                        type="button"
                        icon="pi pi-search"
                        class="p-button"
                        title="Pesquisar Contribuinte"
                      />
                    </div>
                  </template>
                </span>
                <small v-show="validationErrors.cpfCnpjDenunciado" class="p-error"
                  >{{ this.selectedTipoDenunciado && this.selectedTipoDenunciado.key == 'J' ? 'CNPJ' : 'CPF' }}
                  {{ labelPrestador }} é Obrigatório.</small
                >
              </div>
              <div class="col-md-6 mb-2">
                <label for="nomeDenunciado">Nome *:</label>
                <span class="p-fluid">
                  <InputText v-model="pessoaTomador.nome" id="nomeDenunciado" maxlength="80" />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-2">
                <label for="enderecoDenunciado">Endereço *:</label>
                <span class="p-fluid">
                  <InputText v-model="enderecoDenunciadoFormat" id="enderecoDenunciado" maxlength="120" />
                </span>
              </div>
            </div>
          </Panel>
          <Panel :header="'Dados ' + labelPagina">
            <div class="row">
              <div class="col-12 col-md-6 mb-2">
                <label for="categoria">Categoria *:</label>
                <span class="p-fluid">
                  <Dropdown
                    id="categoria"
                    v-model="selectedCategoria"
                    :options="categorias"
                    optionLabel="name"
                    placeholder="Selecione uma Categoria"
                    class="dropdown-modern"
                  />
                </span>
              </div>
              <div class="col-12 col-md-6 mb-2" v-if="selectedCategoria && selectedCategoria.key === 'N'">
                <label for="numeroNfseRps">Número Nfse/RPS *:</label>
                <span class="p-fluid">
                  <InputText v-model="denuncia.numeroNfseRps" id="numeroNfseRps" type="number" />
                </span>
                <small v-show="validationErrors.numeroNfseRps" class="p-error">Número Nfse/RPS é Obrigatório.</small>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-2">
                <label for="assunto">Assunto *:</label>
                <span class="p-fluid">
                  <InputText v-model="denuncia.assunto" id="assunto" maxlength="150" />
                </span>
                <small v-show="validationErrors.assunto" class="p-error"
                  >Assunto da {{ labelPagina }} é Obrigatório.</small
                >
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-2">
                <label for="descricao">Descrição *:</label>
                <span class="p-fluid">
                  <textarea id="descricao" name="descricao" v-model="denuncia.descricao" rows="5" />
                </span>
                <small v-show="validationErrors.descricao" class="p-error"
                  >Descrição da {{ labelPagina }} é Obrigatória.</small
                >
              </div>
            </div>
          </Panel>

          <!-- Botões de Ação -->
          <div class="form-actions-modern">
            <Button
              label="Voltar ao Login"
              type="button"
              class="btn-modern-secondary"
              id="btnVoltar"
              @click="login()"
              icon="pi pi-arrow-left"
              :disabled="loading"
            />
            <Button
              :label="'Gravar ' + labelPagina"
              title="Gravar"
              type="submit"
              class="btn-modern-primary"
              id="btnGravar"
              icon="pi pi-check"
              :disabled="loading"
              v-if="!salvo"
            />
          </div>

          <br />
          <!-- <div class="copyright">© {{ this.anoAtual }} - GPI - Gestão Pública Integrada</div> -->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Denuncia from '../models/nfse/Denuncia';
import DenunciaService from '../services/nfse/denuncia.service';
import DnsClienteService from '../services/nfse/dns.cliente.service';
import Util from '../Utils/util';
import Pessoa from '../models/nfse/Pessoa';

export default {
  data() {
    return {
      anoAtual: null,
      salvo: false,
      loading: false,
      selectedTipoDenuncia: null,
      selectedTipoDenunciante: null,
      selectedTipoDenunciado: null,
      selectedCategoria: null,
      tiposDenuncia: [
        { name: 'Anônima', key: 'A' },
        { name: 'Identificada', key: 'I' },
      ],
      tiposPessoa: [
        { name: 'Jurídica', key: 'J' },
        { name: 'Física', key: 'F' },
      ],
      categorias: [
        { name: 'Denúncia Livre', key: 'L' },
        { name: 'Relacionada a um Número de Nfse ou RPS', key: 'N' },
      ],
      chaveValidacao: null,
      cpfCnpjPrestador: null,
      denuncia: new Denuncia(),
      pessoaTomador: new Pessoa(),
      validationErrors: {},
      selectedMunicipio: null,
      enderecoDenunciadoFormat: null,
    };
  },

  mounted() {
    this.selectedTipoDenuncia = this.tiposDenuncia[0];
    this.selectedTipoDenunciante = this.tiposPessoa[0];
    this.selectedTipoDenunciado = this.tiposPessoa[0];
    this.selectedCategoria = this.categorias[0];
    var d = new Date();
    this.anoAtual = d.getFullYear();

    let host = window.location.hostname;
    DnsClienteService.get(host).then((dns) => {
      this.dnsCliente = dns;
      if (this.dnsCliente && this.dnsCliente.data && this.dnsCliente.data.idCliente) {
        this.idCliente = this.dnsCliente.data.idCliente;
      }
      if (this.chaveValidacao && this.cpfCnpjPrestador) {
        DenunciaService.findDadosManifestacao(this.idCliente, this.cpfCnpjPrestador, this.chaveValidacao).then(
          (data) => {
            const manifestacao = data.data;

            if (data.data) {
              this.selectedTipoDenuncia = this.tiposDenuncia.filter((tipo) => tipo.key == 'I')[0];

              this.selectedTipoDenunciante = this.tiposPessoa.filter((tipo) => tipo.key == manifestacao.tomadorTipo)[0];
              this.denuncia.nomeDenunciante = manifestacao.tomadorNome;
              this.denuncia.cpfCnpjDenunciante = manifestacao.tomadorDocumento;
              this.denuncia.emailDenunciante = manifestacao.tomadorEmail;

              this.selectedTipoDenunciado = this.tiposPessoa.filter(
                (tipo) => tipo.key == manifestacao.prestadorTipo,
              )[0];
              this.denuncia.nomeDenunciado = manifestacao.prestadorNome;
              this.denuncia.cpfCnpjDenunciado = manifestacao.prestadorDocumento;
              this.denuncia.enderecoDenunciado = manifestacao.prestadorEndereco;

              this.selectedCategoria = this.categorias.filter((tipo) => tipo.key == 'N')[0];
              this.denuncia.numeroNfseRps = manifestacao.numeroNfe;
            }
          },
          (error) => {
            let errorMessage = 'Houve um problema ao buscar dados para Manifestação! Preencha manualmente.';
            if (error.response) {
              errorMessage = error.response.data[0];
            }
            this.$toast.add({
              severity: 'error',
              summary: errorMessage,
            });
          },
        );
      }

      this.processando(false);
    }, 250);
  },

  created() {
    try {
      const raw = localStorage.getItem('nfse_login_cache') || sessionStorage.getItem('nfse_login_cache');
      if (raw) {
        const cached = JSON.parse(raw);
        if (cached) {
          this.idCliente = cached.idCliente || null;
        }
      }
    } catch (e) {
      console.warn(e);
    }
    this.limparDados();
    this.chaveValidacao = this.$route.query.chave;
    this.cpfCnpjPrestador = this.$route.query.cpfCnpj;
  },

  methods: {
    limparDados() {
      this.denuncia = new Denuncia();
      this.chaveValidacao = null;
      this.cpfCnpjPrestador = null;
    },

    login() {
      this.$router.push('/login');
    },
    validateForm() {
      if (this.selectedTipoDenuncia && this.selectedTipoDenuncia.key === 'I') {
        if (!this.denuncia.cpfCnpjDenunciante) this.validationErrors['cpfCnpjDenunciante'] = true;
        else delete this.validationErrors['cpfCnpjDenunciante'];

        if (!this.denuncia.nomeDenunciante) this.validationErrors['nomeDenunciante'] = true;
        else delete this.validationErrors['nomeDenunciante'];

        if (!this.denuncia.nomeDenunciante) this.validationErrors['nomeDenunciante'] = true;
        else delete this.validationErrors['nomeDenunciante'];
      }
      if (!this.denuncia.cpfCnpjDenunciado) this.validationErrors['cpfCnpjDenunciado'] = true;
      else delete this.validationErrors['cpfCnpjDenunciado'];

      if (!this.denuncia.assunto) this.validationErrors['assunto'] = true;
      else delete this.validationErrors['assunto'];

      if (!this.denuncia.descricao) this.validationErrors['descricao'] = true;
      else delete this.validationErrors['descricao'];

      if (this.selectedCategoria && this.selectedCategoria.key === 'N' && !this.denuncia.numeroNfseRps)
        this.validationErrors['numeroNfseRps'] = true;
      else delete this.validationErrors['numeroNfseRps'];

      return !Object.keys(this.validationErrors).length;
    },
    onSubmit() {
      this.loading = true;

      if (this.validateForm()) {
        this.salvar();
      }

      this.loading = false;
    },
    salvar() {
      this.denuncia.idCliente = this.idCliente;
      this.denuncia.idBolCategoria = this.selectedCategoria.key;
      this.denuncia.idBolTipo = this.selectedTipoDenuncia.key;
      this.denuncia.idBolSituacao = 'A';
      this.denuncia.nomeDenunciado = this.pessoaTomador.nome;
      this.denuncia.enderecoDenunciado = this.enderecoDenunciadoFormat;

      if (this.isManifestacao) {
        this.denuncia.idBolManifestacao = 'S';
      }

      DenunciaService.save(this.denuncia).then(
        (data) => {
          console.log(data);
          this.$toast.add({
            severity: 'success',
            summary: this.labelPagina + ' registrada com sucesso!',
          });
          this.salvo = true;
        },
        (error) => {
          let errorMessage = 'Houve um problema ao salvar a ' + this.labelPagina + '!';
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: 'error',
            summary: errorMessage,
          });
        },
      );
    },
    searchContribuintePorCpfCnpj() {
      const documento = this.denuncia.cpfCnpjDenunciado;
      if (documento !== '' && this.validarDocumento()) {
        this.processando(true);
        DenunciaService.findAllByTipoCpfCnpjDenunciaFis(this.idCliente, documento)
          .then(
            (data) => {
              console.log(data);

              if (data.length) {
                this.contribuintes = data;
                this.preencherDadosTomador(this.contribuintes[0]);
              } else {
                if (this.denuncia.idContribuinteDenunciado) {
                  this.limparDadosTomador();
                  this.denuncia.cpfCnpjDenunciado = documento;
                }
              }
            },
            (error) => {
              if (error.response.data) {
                this.denuncia.cpfCnpjDenunciado = null;
                this.$root.$emit('alert:warn', error.response.data);
              } else {
                this.$root.$emit('alert:warn', 'não foi possível consultar o cadastro!');
              }
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        if (this.denuncia.idContribuinteDenunciado) {
          this.limparDadosTomador();
          this.denuncia.cpfCnpjDenunciado = documento;
        }
      }
    },
    preencherDadosTomador(contribuinte) {
      this.pessoaTomador.id = contribuinte.idPessoa && contribuinte.idPessoa.id ? contribuinte.idPessoa.id : null;
      this.preencherContrTomador(contribuinte);
      this.denuncia.cpfCnpjDenunciado = contribuinte.idPessoa.numeroDocumentoJuridico;
      this.pessoaTomador.nome = contribuinte.idPessoa.nomeGeral;
      this.pessoaTomador.cep = contribuinte.cep;
      this.selectedMunicipio = contribuinte.idLocalidadeMunicipio;
      this.pessoaTomador.bairro = contribuinte.idBairro ? contribuinte.idBairro.nomeBairro : '';
      this.pessoaTomador.tipoLogradouro =
        contribuinte.idLogradouro && contribuinte.idLogradouro.idCepTipoLogra
          ? contribuinte.idLogradouro.idCepTipoLogra.nomeTipoLogra
          : '';
      this.pessoaTomador.logradouro = contribuinte.idLogradouro ? contribuinte.idLogradouro.nomeLogradouro : '';
      this.pessoaTomador.numero = contribuinte.numeroLogradouro;
      this.pessoaTomador.complemento = contribuinte.complementoLogradouro;

      this.pessoaTomador.email = contribuinte.contatos.email;
      this.pessoaTomador.site = contribuinte.contatos.site;
      this.pessoaTomador.telefone = contribuinte.contatos.telefone;
      this.pessoaTomador.celular = contribuinte.contatos.celular;

      this.enderecoDenunciadoFormat = `${this.pessoaTomador.tipoLogradouro || ''} ${this.pessoaTomador.logradouro ||
        ''}, ${this.pessoaTomador.numero || ''}${
        this.pessoaTomador.complemento ? ' - ' + this.pessoaTomador.complemento : ''
      }, ${this.pessoaTomador.bairro || ''}, ${(this.selectedMunicipio && this.selectedMunicipio.nomeMunicipio) ||
        ''} - ${this.pessoaTomador.cep || ''}`;
    },
    preencherContrTomador(contribuinte) {
      this.pessoaTomador.idContribuinte = contribuinte.id;
    },
    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.denuncia.cpfCnpjDenunciado);

      if (!validar) {
        console.log(validar);
        this.$root.$emit('alert:error', 'CPF/CNPJ ' + this.denuncia.cpfCnpjDenunciado + ' inválido!');
        this.denuncia.cpfCnpjDenunciado = null;
      }
      return validar;
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit('loading:show');
      } else {
        this.loading = false;
        this.$root.$emit('loading:hide');
      }
    },
  },

  computed: {
    isManifestacao() {
      return this.chaveValidacao && this.cpfCnpjPrestador;
    },

    labelPagina() {
      return this.isManifestacao ? 'Manifestação' : 'Denúncia Fiscal';
    },

    labelTomador() {
      return this.isManifestacao ? 'Tomador' : 'Denunciante';
    },

    labelPrestador() {
      return this.isManifestacao ? 'Prestador' : 'Denunciado';
    },
  },
};
</script>

<style src="../assets/css/links-autenticacao-recibo-credenciamento-contribuintes.css"></style>

